import DemoBadge from '@/components/feature/DemoBadge';
import { INCLUSIVE_CATEGORIES, CATEGORY_INTEGRITY_NOTE } from '@/lib/multilingual';

/**
 * Shows the editorial categories that keep community coverage inclusive.
 * Categories describe programs, events and organizations — never people.
 */
export default function InclusiveCoverage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-heading font-extrabold uppercase text-xl md:text-2xl text-foreground-950">Inclusive community coverage</h2>
        <DemoBadge label="Sample categories" />
      </div>

      <p className="text-sm text-foreground-600 max-w-3xl">
        Coverage is organised around the communities, programmes and events that make up local golf — not around assumptions about who plays it.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
        {INCLUSIVE_CATEGORIES.map((c) => (
          <article key={c.id} className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col">
            <div className="flex items-center justify-between gap-2">
              <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center text-xl"><i className={c.icon}></i></span>
              <span className="font-label font-bold text-[11px] text-foreground-500 bg-background-100 border border-background-200 rounded-full px-2 py-0.5">{c.sampleCount} sample stories</span>
            </div>
            <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950 leading-snug">{c.label}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{c.description}</p>
          </article>
        ))}
      </div>

      <div className="bg-secondary-50 border border-secondary-200 rounded-lg p-4 md:p-5 flex items-start gap-3">
        <span className="w-9 h-9 rounded-md bg-secondary-500 text-foreground-950 flex items-center justify-center text-xl shrink-0"><i className="ri-shield-check-line"></i></span>
        <div>
          <p className="font-heading font-bold text-lg text-foreground-950">How we categorise</p>
          <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{CATEGORY_INTEGRITY_NOTE}</p>
        </div>
      </div>
    </div>
  );
}